import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import { a as AppIcon, A as AppText } from './index-6b88191c.esm.js';
import PropTypes from 'prop-types';
import React__default, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { View, TextInput, TouchableOpacity, StyleSheet } from 'react-native';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { A as AppInputLabel } from './index-5ae71f5a.esm.js';
import { A as AppTextChip } from './index-1487832e.esm.js';
import { A as AppActivityIndicator } from './index-2b5eefb0.esm.js';
import { A as AppAssets } from './index-3256db5b.esm.js';

function validateEmail(input) {
  var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (input !== null && input !== void 0 && input.match(validRegex)) {
    return true;
  } else {
    return false;
  }
}

let INPUT_TYPE = /*#__PURE__*/function (INPUT_TYPE) {
  INPUT_TYPE["EMAIL"] = "email";
  INPUT_TYPE["MENTION"] = "mention";
  INPUT_TYPE["SUBJECT"] = "subject";
  INPUT_TYPE["PROMPT"] = "prompt";
  return INPUT_TYPE;
}({});
function AppTextInput(_ref) {
  var _currentTheme$theme3, _currentTheme$theme4, _currentTheme$theme5, _currentTheme$theme6, _currentTheme$theme7, _currentTheme$theme8, _currentTheme$theme9, _currentTheme$theme10, _AppAssets$icons, _AppAssets$icons2, _currentTheme$theme11, _currentTheme$theme12, _currentTheme$theme13, _currentTheme$theme14;
  let {
    icon,
    autoCapitalise,
    onChangeText = () => {},
    onDeleteTagClick = () => {},
    onTagsChanged = () => {},
    onTagAdded = () => {},
    onRightIconClick,
    onLeftIconClick,
    value,
    placeholder,
    label,
    iconColor,
    isMandatory,
    width,
    showTextChips,
    style,
    topIcon,
    leftIcon,
    leftIconSize,
    topIconSize,
    rightIcon,
    rightIconSize,
    showTextInputLabel,
    wrapperInputStyle,
    backgroundColor,
    textContainer,
    tagsContainerStyle,
    inputType,
    isTagDeletable,
    isListDisplayedUnder = false,
    tagStyle,
    tags = [],
    forcedValidationError,
    isQueryInProgress,
    accessibilityLabel,
    multiline,
    textInputLabelStyle,
    maxCharacters,
    validationErrorStyle,
    rightIconStyle,
    rightIconLabel,
    defaultValue,
    hideShowIcon = false,
    isRightLabelFixed = false,
    mentioning = false,
    maxMentionsMenuHeight = 350,
    mentions = [],
    onMentionSelect = () => {},
    labelStyle,
    ...otherProps
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const [isMouseOver, setIsMouseOver] = useState(false);
  const [inputTags, setInputTags] = useState(tags);
  const [validationError, setValidationError] = useState(null);
  const [mentionListVisible, setMentionListVisible] = useState(false);
  const [mentionQuery, setMentionQuery] = useState("");
  const [cursorPosition, setCursorPosition] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedMentions, setSelectedMentions] = useState([]);
  useRef(null);
  const isPositionWithinMention = position => {
    return selectedMentions.some(mention => position > mention.start && position <= mention.end);
  };
  const [showValue, setShowValue] = useState(false);
  const styles = generateStyle(currentTheme, leftIcon || rightIcon, isListDisplayedUnder);
  const {
    t
  } = useTranslation();
  const ref = useRef(null);
  useEffect(() => {
    onTagsChanged(inputTags);
  }, [JSON.stringify(inputTags)]);
  useEffect(() => {
    setInputTags(tags);
  }, [tags === null || tags === void 0 ? void 0 : tags.length]);
  const validateInput = text => {
    var _inputTags$filter;
    switch (inputType) {
      case INPUT_TYPE.EMAIL:
        const isEmail = validateEmail(text);
        const isValueUnique = (inputTags === null || inputTags === void 0 ? void 0 : (_inputTags$filter = inputTags.filter(u => u === text)) === null || _inputTags$filter === void 0 ? void 0 : _inputTags$filter.length) === 0;
        if (!isEmail) setValidationError("Invalid email address");
        if (!isValueUnique) setValidationError("The email address already exists");
        return isEmail && isValueUnique;
      default:
        return true;
    }
  };
  const onTextChipSubmit = text => {
    if (text !== "" && validateInput(text)) {
      onTagAdded(text);
      if (showTextChips) {
        inputTags.push(text);
        setInputTags([...inputTags]);
        onChangeText("");
      }
    }
  };
  const handleDeleteTagClick = item => {
    if (item) {
      onDeleteTagClick(item);
      var filtered = inputTags.filter(function (value) {
        return value !== item;
      });
      setInputTags([...filtered]);
    }
  };
  useEffect(() => {
    if (ref) {
      ref.current.setNativeProps({
        style: {
          fontFamily: "normalFont"
        }
      });
    }
  }, []);
  const handleKeyPress = event => {
    switch (event.nativeEvent.key) {
      case "ArrowDown":
        event.preventDefault();
        setSelectedIndex(prev => prev < (filteredMentions === null || filteredMentions === void 0 ? void 0 : filteredMentions.length) - 1 ? prev + 1 : prev);
        break;
      case "ArrowUp":
        event.preventDefault();
        setSelectedIndex(prev => prev > 0 ? prev - 1 : prev);
        break;
      case "Enter":
        if (mentioning) {
          event.preventDefault();
          if (filteredMentions[selectedIndex]) {
            handleMentionSelect(filteredMentions[selectedIndex]);
          }
        }
        break;
      case "Escape":
        setMentionListVisible(false);
        setSelectedIndex(0);
        break;
    }
  };
  const handleMentionSelect = mention => {
    const lastAtSymbolIndex = value.lastIndexOf("@", cursorPosition);
    const beforeMention = value.slice(0, lastAtSymbolIndex);
    const afterMention = value.slice(cursorPosition);
    const newText = "".concat(beforeMention, "@").concat(mention.label, " ").concat(afterMention);

    // Add to selected mentions
    setSelectedMentions(prev => {
      var _mention$label;
      return [...prev, {
        label: mention.label,
        start: lastAtSymbolIndex,
        end: lastAtSymbolIndex + ((_mention$label = mention.label) === null || _mention$label === void 0 ? void 0 : _mention$label.length) + 1 // +1 for @ symbol
      }];
    });

    onChangeText === null || onChangeText === void 0 ? void 0 : onChangeText(newText);
    onMentionSelect === null || onMentionSelect === void 0 ? void 0 : onMentionSelect(mention);
    setMentionListVisible(false);
    setSelectedIndex(0);
  };
  const filteredMentions = mentions.filter(mention => mention.label.toLowerCase().includes(mentionQuery.toLowerCase()));
  return /*#__PURE__*/React__default.createElement(View, {
    style: [styles.wrapperInputStyle, wrapperInputStyle]
  }, showTextChips ? /*#__PURE__*/React__default.createElement(View, {
    style: [styles.tagsContainer, tagsContainerStyle]
  }, inputTags === null || inputTags === void 0 ? void 0 : inputTags.map((i, y) => /*#__PURE__*/React__default.createElement(AppTextChip, {
    styleContainer: tagStyle,
    isTagDeletable: isTagDeletable,
    key: y,
    onDeleteClick: handleDeleteTagClick,
    label: i
  }))) : null, showTextInputLabel ? /*#__PURE__*/React__default.createElement(AppInputLabel, {
    style: [{
      marginLeft: 10
    }, textInputLabelStyle],
    isMandatory: isMandatory,
    label: label
  }) : null, topIcon && /*#__PURE__*/React__default.createElement(AppIcon, {
    accessibilityLabel: "".concat(accessibilityLabel, "_top_icon"),
    color: iconColor,
    icon: topIcon,
    size: topIconSize || 24,
    style: {
      backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme3 = currentTheme.theme) === null || _currentTheme$theme3 === void 0 ? void 0 : _currentTheme$theme3.transparent
    }
  }), multiline ? /*#__PURE__*/React__default.createElement(TextInput, _extends({
    ref: ref,
    value: autoCapitalise ? value === null || value === void 0 ? void 0 : value.toUpperCase() : value,
    multiline: multiline
  }, otherProps, {
    accessibilityLabel: accessibilityLabel,
    onKeyPress: event => {
      if (mentioning && mentionListVisible && (filteredMentions === null || filteredMentions === void 0 ? void 0 : filteredMentions.length) > 0) {
        handleKeyPress(event);
      } else if ((event === null || event === void 0 ? void 0 : event.nativeEvent.key) === "Enter") onTextChipSubmit(value);
    },
    onSelectionChange: event => {
      setCursorPosition(event.nativeEvent.selection.start);
    },
    onChangeText: text => {
      text[cursorPosition - 1];
      const newChar = text.charAt(cursorPosition);
      const isAddingMention = newChar === "@";
      if (validationError) setValidationError(null);

      // Check if we're currently in a mention context
      const lastAtSymbolIndex = text.lastIndexOf("@", cursorPosition);
      const textAfterAt = text.slice(lastAtSymbolIndex + 1, cursorPosition);
      const isInMentionContext = lastAtSymbolIndex !== -1 && !isPositionWithinMention(lastAtSymbolIndex);
      if (isAddingMention) {
        setMentionListVisible(true);
        setMentionQuery("");
        setSelectedIndex(0);
      } else if (isInMentionContext) {
        setMentionListVisible(true);
        setMentionQuery(textAfterAt);
      } else {
        setMentionListVisible(false);
      }
      onChangeText && onChangeText(autoCapitalise ? text === null || text === void 0 ? void 0 : text.toUpperCase() : text);
    },
    style: [styles.textContainer, {
      width: width,
      backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme4 = currentTheme.theme) === null || _currentTheme$theme4 === void 0 ? void 0 : _currentTheme$theme4.inputBackgroundColor,
      marginHorizontal: 10
    }, styles.text, textContainer],
    placeholder: t(placeholder),
    placeholderTextColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme5 = currentTheme.theme) === null || _currentTheme$theme5 === void 0 ? void 0 : _currentTheme$theme5.inputPlaceholderColor
  })) : /*#__PURE__*/React__default.createElement("div", {
    onMouseEnter: () => {
      setIsMouseOver(true);
    },
    onMouseLeave: () => {
      setIsMouseOver(false);
    },
    style: {
      cursor: "pointer"
    }
  }, /*#__PURE__*/React__default.createElement(View, {
    style: [styles.textContainer, {
      width: width,
      backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme6 = currentTheme.theme) === null || _currentTheme$theme6 === void 0 ? void 0 : _currentTheme$theme6.inputBackgroundColor
    }, textContainer]
  }, leftIcon && !isQueryInProgress && /*#__PURE__*/React__default.createElement(AppIcon, {
    isClickable: onLeftIconClick !== null,
    onPress: onLeftIconClick,
    accessibilityLabel: "".concat(accessibilityLabel, "_left_icon"),
    color: iconColor,
    icon: leftIcon,
    size: leftIconSize || 18,
    style: {
      backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme7 = currentTheme.theme) === null || _currentTheme$theme7 === void 0 ? void 0 : _currentTheme$theme7.transparent,
      flex: 0
    }
  }), /*#__PURE__*/React__default.createElement(AppActivityIndicator, {
    visible: isQueryInProgress,
    containerStyle: {
      alignItems: "flex-start",
      flex: 0,
      flexBasis: 24
    },
    size: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme8 = currentTheme.theme) === null || _currentTheme$theme8 === void 0 ? void 0 : _currentTheme$theme8.medium_font_size
  }), /*#__PURE__*/React__default.createElement(TextInput, _extends({
    ref: ref,
    secureTextEntry: hideShowIcon && !showValue,
    value: autoCapitalise ? value === null || value === void 0 ? void 0 : value.toUpperCase() : value
  }, otherProps, {
    accessibilityLabel: accessibilityLabel,
    onKeyPress: event => {
      if ((event === null || event === void 0 ? void 0 : event.nativeEvent.key) === "Enter") onTextChipSubmit(value);
    },
    onChangeText: text => {
      if (validationError) setValidationError(null);
      if (inputType === INPUT_TYPE.PROMPT) {
        if ((text === null || text === void 0 ? void 0 : text.length) === 0 || (text === null || text === void 0 ? void 0 : text.length) < maxCharacters) onChangeText(text);else {
          setValidationError("The text has reached the maximum length");
        }
      } else {
        onChangeText && onChangeText(autoCapitalise ? text === null || text === void 0 ? void 0 : text.toUpperCase() : text);
      }
    },
    style: [styles.text, style],
    placeholder: t(placeholder),
    placeholderTextColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme9 = currentTheme.theme) === null || _currentTheme$theme9 === void 0 ? void 0 : _currentTheme$theme9.inputPlaceholderColor
  })), hideShowIcon && /*#__PURE__*/React__default.createElement(AppIcon, {
    justifyHorizontally: true,
    labelStyle: {
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme10 = currentTheme.theme) === null || _currentTheme$theme10 === void 0 ? void 0 : _currentTheme$theme10.primary
    },
    showToLeft: true,
    showToRight: false,
    label: "",
    accessibilityLabel: "".concat(accessibilityLabel, "_right_icon"),
    isClickable: true,
    onPress: () => {
      setShowValue(!showValue);
    },
    color: iconColor,
    icon: showValue ? AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons = AppAssets.icons) === null || _AppAssets$icons === void 0 ? void 0 : _AppAssets$icons.hide : AppAssets === null || AppAssets === void 0 ? void 0 : (_AppAssets$icons2 = AppAssets.icons) === null || _AppAssets$icons2 === void 0 ? void 0 : _AppAssets$icons2.show,
    size: rightIconSize || 18,
    wrapperStyle: {
      marginRight: 5
    },
    style: [{
      backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme11 = currentTheme.theme) === null || _currentTheme$theme11 === void 0 ? void 0 : _currentTheme$theme11.transparent,
      flex: 0,
      width: "auto"
    }, rightIconStyle]
  }), rightIcon && /*#__PURE__*/React__default.createElement(AppIcon, {
    justifyHorizontally: true,
    labelStyle: [{
      color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme12 = currentTheme.theme) === null || _currentTheme$theme12 === void 0 ? void 0 : _currentTheme$theme12.primary
    }, labelStyle],
    showToLeft: true,
    showToRight: false,
    label: (isMouseOver || isRightLabelFixed) && rightIconLabel,
    accessibilityLabel: "".concat(accessibilityLabel, "_right_icon"),
    isClickable: onRightIconClick !== null,
    onPress: () => {
      if (validateInput(value)) onRightIconClick && onRightIconClick(value);
    },
    color: iconColor,
    icon: rightIcon,
    size: rightIconSize || 18,
    style: [{
      backgroundColor: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme13 = currentTheme.theme) === null || _currentTheme$theme13 === void 0 ? void 0 : _currentTheme$theme13.transparent,
      flex: 0,
      width: "auto"
    }, rightIconStyle]
  }))), (validationError || forcedValidationError) && /*#__PURE__*/React__default.createElement(AppText, {
    wrapperStyle: [{
      position: "absolute",
      top: -15,
      left: 26
    }, validationErrorStyle],
    color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme14 = currentTheme.theme) === null || _currentTheme$theme14 === void 0 ? void 0 : _currentTheme$theme14.red,
    accessibilityLabel: "".concat(accessibilityLabel, "_error_text")
  }, validationError || forcedValidationError), mentionListVisible && /*#__PURE__*/React__default.createElement(View, {
    style: [styles.mentionList, {
      maxHeight: maxMentionsMenuHeight
    }],
    accessibilityRole: "list",
    accessibilityLabel: "Mention suggestions"
  }, filteredMentions.map((mention, index) => /*#__PURE__*/React__default.createElement(TouchableOpacity, {
    key: mention.id,
    onPress: () => handleMentionSelect(mention),
    style: [styles.mentionItem, index === selectedIndex && styles.selectedMentionItem],
    accessibilityRole: "button",
    accessibilityLabel: "Suggest ".concat(mention.label),
    accessibilityState: {
      selected: index === selectedIndex
    }
  }, /*#__PURE__*/React__default.createElement(AppText, {
    style: index === selectedIndex ? styles.selectedMentionText : undefined
  }, mention.label)))));
}
const generateStyle = (props, isIconEmbedded, isListDisplayedUnder) => {
  var _props$theme, _props$theme2, _props$theme3, _props$theme4, _props$theme5, _props$theme6, _props$theme7, _props$theme8, _props$theme9, _props$theme10;
  return StyleSheet.create({
    wrapperInputStyle: {
      flexDirection: isListDisplayedUnder ? "column-reverse" : "column"
    },
    container: {
      display: "flex",
      flexDirection: "column"
    },
    textContainer: {
      margin: 5,
      flexDirection: "row",
      alignItems: "center",
      borderRadius: 10,
      borderColor: props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.border_color,
      borderWidth: 1,
      height: props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.fieldHeight,
      paddingHorizontal: isIconEmbedded ? 20 : 15
    },
    text: {
      marginHorizontal: isIconEmbedded ? 20 : 0,
      flex: 1,
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.small_font_size,
      color: props === null || props === void 0 ? void 0 : (_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.darkGrey,
      fontFamily: "normalFont",
      backgroundColor: props === null || props === void 0 ? void 0 : (_props$theme5 = props.theme) === null || _props$theme5 === void 0 ? void 0 : _props$theme5.inputBackgroundColor
    },
    tagsContainer: {
      flexDirection: "row",
      flexWrap: "wrap"
    },
    mentionText: {
      color: "#2196F3",
      fontWeight: "500",
      backgroundColor: "rgba(33, 150, 243, 0.1)",
      borderRadius: 4,
      paddingHorizontal: 4,
      marginHorizontal: 2
    },
    highlightedMention: {
      color: props === null || props === void 0 ? void 0 : (_props$theme6 = props.theme) === null || _props$theme6 === void 0 ? void 0 : _props$theme6.primary,
      // or your theme color
      fontWeight: "500"
    },
    selectedMentionItem: {
      backgroundColor: props === null || props === void 0 ? void 0 : (_props$theme7 = props.theme) === null || _props$theme7 === void 0 ? void 0 : _props$theme7.primary_soft // light blue background for selected item
    },

    selectedMentionText: {
      color: props === null || props === void 0 ? void 0 : (_props$theme8 = props.theme) === null || _props$theme8 === void 0 ? void 0 : _props$theme8.primary,
      fontWeight: "500"
    },
    mentionList: {
      position: "absolute",
      top: "100%",
      left: 0,
      right: 0,
      backgroundColor: props === null || props === void 0 ? void 0 : (_props$theme9 = props.theme) === null || _props$theme9 === void 0 ? void 0 : _props$theme9.backgroundContrastColor,
      borderRadius: 4,
      elevation: 4,
      shadowColor: props === null || props === void 0 ? void 0 : (_props$theme10 = props.theme) === null || _props$theme10 === void 0 ? void 0 : _props$theme10.lightGrey,
      shadowOffset: {
        width: 0,
        height: 2
      },
      shadowOpacity: 0.25,
      shadowRadius: 3.84,
      overflowY: "auto"
    },
    mentionItem: {
      padding: 10
    }
  });
};
AppTextInput.propsTypes = {
  placeholder: PropTypes.string
};
AppTextInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppTextInput",
  "props": {
    "onChangeText": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(text: string) => void",
        "signature": {
          "arguments": [{
            "name": "text",
            "type": {
              "name": "string"
            }
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "onDeleteTagClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(item: any) => void",
        "signature": {
          "arguments": [{
            "name": "item",
            "type": {
              "name": "any"
            }
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "onTagsChanged": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(item: any) => void",
        "signature": {
          "arguments": [{
            "name": "item",
            "type": {
              "name": "any"
            }
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "onTagAdded": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(item: any) => void",
        "signature": {
          "arguments": [{
            "name": "item",
            "type": {
              "name": "any"
            }
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "isListDisplayedUnder": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "tags": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "Array",
        "elements": [{
          "name": "any"
        }],
        "raw": "any[]"
      },
      "description": ""
    },
    "hideShowIcon": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "isRightLabelFixed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "mentioning": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "maxMentionsMenuHeight": {
      "defaultValue": {
        "value": "350",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    },
    "mentions": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "Array",
        "elements": [{
          "name": "signature",
          "type": "object",
          "raw": "{\n  id: string | number;\n  label: string;\n  // optional additional metadata\n  avatar?: string;\n  type?: string;\n}",
          "signature": {
            "properties": [{
              "key": "id",
              "value": {
                "name": "union",
                "raw": "string | number",
                "elements": [{
                  "name": "string"
                }, {
                  "name": "number"
                }],
                "required": true
              }
            }, {
              "key": "label",
              "value": {
                "name": "string",
                "required": true
              }
            }, {
              "key": "avatar",
              "value": {
                "name": "string",
                "required": false
              }
            }, {
              "key": "type",
              "value": {
                "name": "string",
                "required": false
              }
            }]
          }
        }],
        "raw": "Array<{\n  id: string | number;\n  label: string;\n  // optional additional metadata\n  avatar?: string;\n  type?: string;\n}>"
      },
      "description": ""
    },
    "onMentionSelect": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(mention: { id: string | number; label: string }) => void",
        "signature": {
          "arguments": [{
            "name": "mention",
            "type": {
              "name": "signature",
              "type": "object",
              "raw": "{ id: string | number; label: string }",
              "signature": {
                "properties": [{
                  "key": "id",
                  "value": {
                    "name": "union",
                    "raw": "string | number",
                    "elements": [{
                      "name": "string"
                    }, {
                      "name": "number"
                    }],
                    "required": true
                  }
                }, {
                  "key": "label",
                  "value": {
                    "name": "string",
                    "required": true
                  }
                }]
              }
            }
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "icon": {
      "required": false,
      "tsType": {
        "name": "IconDefinition"
      },
      "description": ""
    },
    "autoCapitalise": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "onRightIconClick": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(item: any) => void",
        "signature": {
          "arguments": [{
            "name": "item",
            "type": {
              "name": "any"
            }
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "onLeftIconClick": {
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "() => void",
        "signature": {
          "arguments": [],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "value": {
      "required": true,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "placeholder": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "label": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "isMandatory": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "width": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    },
    "showTextChips": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "style": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": ""
    },
    "topIcon": {
      "required": false,
      "tsType": {
        "name": "IconDefinition"
      },
      "description": ""
    },
    "leftIcon": {
      "required": false,
      "tsType": {
        "name": "IconDefinition"
      },
      "description": ""
    },
    "leftIconSize": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    },
    "topIconSize": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    },
    "rightIcon": {
      "required": false,
      "tsType": {
        "name": "IconDefinition"
      },
      "description": ""
    },
    "rightIconSize": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    },
    "showTextInputLabel": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "wrapperInputStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": ""
    },
    "backgroundColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "textContainer": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": ""
    },
    "tagsContainerStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": ""
    },
    "textInputLabelStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": ""
    },
    "validationErrorStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": ""
    },
    "labelStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": ""
    },
    "rightIconStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": ""
    },
    "tagStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": ""
    },
    "inputType": {
      "required": false,
      "tsType": {
        "name": "INPUT_TYPE"
      },
      "description": ""
    },
    "isTagDeletable": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "multiline": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "iconColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "forcedValidationError": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "isQueryInProgress": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "accessibilityLabel": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "maxCharacters": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    },
    "rightIconLabel": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "defaultValue": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    }
  }
};

export { AppTextInput as A };
